import { AccountsToReceive } from '@/pages/AccountsToReceive/AccountsToReceive';
import { Dashboard } from '@/pages/Dashboard/Dashboard.tsx';
import { InadimplenciaPage } from '@/pages/InadimplenciaPage/InadimplenciaPage';
import TermometroGeral from '@/pages/TermometroGeral/TermometroGeral';
import RaioX from '@/features/dashboard/RaioX';
import IndiceValor from '@/features/dashboard/IndiceValor';
import CashFlowTela from '@/features/dashboard/CashFlowTela';
import { CrmPageNew } from '@/pages/CrmPage/CrmPageNew';
import { OccupancyPanel } from '@/pages/OccupancyPanel/OccupancyPanel';
import ScorePedagogico from '@/pages/ScorePedagogico/ScorePedagogico';
import { TypesCRM } from '@/types/crm.ts';

export const listPermissions = {
  contas_receber: {
    container: AccountsToReceive,
    route: '/accounts-to-receive'
  },
  dashboard: {
    container: Dashboard,
    route: '/dashboard'
  },
  inadimplencia: {
    container: InadimplenciaPage,
    route: '/inadimplencia'
  },
  termometro: {
    container: TermometroGeral,
    route: '/termometro-geral'
  },
  raixo_x: {
    container: RaioX,
    route: '/raiox'
  },
  indice_valor: {
    container: IndiceValor,
    route: '/indice-valor'
  },
  fluxo_caixa: {
    container: CashFlowTela,
    route: '/fluxo-caixa'
  },
  crm: {
    container: CrmPageNew,
    route: '/crm/matricula',
    props: {
      title: 'CRM Matrícula',
      type: TypesCRM.MATRICULA
    }
  },
  painel_ocupacao: {
    container: OccupancyPanel,
    route: '/occupancy-panel'
  },
  score_pedagogico: {
    container: ScorePedagogico,
    route: '/score-pedagogico'
  },
};

/**
 * Determina a rota padrão para o usuário baseado em suas permissões
 * Aplica a mesma lógica do menu lateral
 */
export const getDefaultRouteForUser = (permissions: string[] = []): string => {
  // Aplica a mesma lógica de filtro do menu - só permite páginas que o usuário tem acesso
  const allowedPermissions = Object.keys(listPermissions).filter((key) => 
    permissions.length === 0 || permissions.some((perm) => perm.includes(key))
  );

  // Se não tem permissões específicas, vai para dashboard
  if (permissions.length === 0) {
    return '/dashboard';
  }
  
  // Pega a primeira permissão permitida
  const firstAllowedPermission = allowedPermissions[0];
  if (firstAllowedPermission && listPermissions[firstAllowedPermission]) {
    const route = listPermissions[firstAllowedPermission].route;
    return route;
  }
  
  // fallback para dashboard
  return '/dashboard';
};

/**
 * Verifica se um usuário tem permissão para acessar uma rota específica
 */
export const hasPermissionForRoute = (requiredPermission: string, permissions: string[] = []): boolean => {
  if (!requiredPermission) return true;
  
  return permissions.length === 0 || permissions.some((perm) => perm.includes(requiredPermission));
};